import React, { Component } from 'react';
import resumeData from 'resumeData';
import { MagicTabSelect } from "react-magic-motion";
// import { AiFillGithub } from "react-icons/ai";

export interface Props { }
export interface State {
  skillsCategory: string[]
  skillsfilter: string[]
  activeTab: number
  indicatorPosition: number
}

export class Skills extends Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      skillsCategory: [],
      skillsfilter: [],
      activeTab: 0,
      indicatorPosition: 0,
    }
  }
  componentDidMount() {
    if (resumeData?.skills) {
      this.setState({ skillsCategory: Object.keys(resumeData.skills) })
    }
  }
  displayTechnicalSkillsContainer = () => {

    const { skillsCategory } = this.state
    const tabHeaders = skillsCategory
    const tabContents = Object.values(resumeData.skills)
    console.log(this.state.indicatorPosition)
    return (

      <div className='tabs'>
      <div className='tabs-header'>
          {tabHeaders.map((header, index) => (
            <div
              key={index}
              className={`tab ${index === this.state.activeTab ? 'active' : ''}`}
              onClick={() => this.handleTabClick(index)}
            >
              {header}
            </div>
          ))}
        </div>
        <div className='tabs-indicator' style={{ top: `calc(8rem + ${this.state.indicatorPosition}rem)` }}></div>
        <div className='tabs-content' data-aos="zoom-out-down">
          {tabContents.map((content, index) => (
            <div
              key={index}
              className={`tabs-content-item ${index === this.state.activeTab ? 'active' : ''}`}
            >
              {content.map((item, index) => (
                <MagicTabSelect
                  id="underline"
                  transition={{ type: "spring", bounce: 0.3 }}
                >
                  <div className="tabs-content-item__sub sub-heading-gray" key={index}>
                    <svg>
                      <use xlinkHref={`SVG/symbol-defs.svg#icon-${item.svgId}`}></use>
                    </svg>
                    <p>{item.value}</p>
                  </div>
                </MagicTabSelect>
              ))}
            </div>
          ))}
        </div>
      </div>
    )
  }
  handleTabClick = (index: number) => {
    const indicatorPosition = index * 5; // Assuming each tab is 50px high
    console.log(indicatorPosition)
    this.setState({ activeTab: index, indicatorPosition });
  };

  render() {


    return (
      <div className='skills'>
        
        <div className="skills__container">
          <div className="skills__header heading-title u-margin-top-small u-margin-left-medium">Technical Skills</div>
          {/* <div className="bg-video">
            <video className="bg-video__content" autoPlay muted loop>
              <source src="img/coverr-waves-splashing-onto-a-rocky-shore-in-the-distance.mp4" type="video/mp4" />
              <source src="img/video.webm" type="video/webm" />
              Your browser is not supported!
            </video>
          </div> */}
          <MagicTabSelect
            id="underline"
            transition={{ type: "spring", bounce: 0.5 }}
          >
            {this.displayTechnicalSkillsContainer()}
          </MagicTabSelect>

        </div>
      </div>
    );
  }
}

export default Skills;
